import React, {
  CSSProperties,
  forwardRef,
  ReactNode,
  TextareaHTMLAttributes,
} from "react";
import styled from "@emotion/styled";
import useLabel from "../LabelWrapper/useLabel";
import { css } from "../../../utils/ide";

const StyledTextarea = styled.textarea<StyledTextareaProps>(
  ({ theme, resize, sharperColor }) => css`
    background-color: ${theme.background.secondary};
    box-sizing: border-box;
    color: ${sharperColor ? theme.text.primary : theme.text.secondary};
    border-radius: 5px;
    font-size: 1em;
    margin: 0 auto;
    min-height: 100px;
    padding: 10px;
    width: 100%;
    resize: ${resize};
  `
);

const TextArea = forwardRef<HTMLTextAreaElement, Props>((props: Props, ref) => {
  const { cy, ...rest } = props;
  const withLabel = useLabel(props.label, props.required);

  const el = <StyledTextarea ref={ref} {...rest} data-cy={cy} />;
  return withLabel(el);
});

type StyledTextareaProps = {
  resize?: CSSProperties["resize"];
  sharperColor?: boolean;
};

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> &
  StyledTextareaProps & {
    cy?: string;
    label?: ReactNode;
    required?: boolean;
  };

export default TextArea;
